import { RumInitConfiguration } from "@datadog/browser-rum";

export class DatadogResolver {
  static resolveConfig(
    environment: string,
    version: string | undefined
  ): RumInitConfiguration {
    const useSbx =
      environment === "dev" ||
      (process.env["NODE_ENV"] === "development" &&
        process.env["REACT_APP_BUILD_NUMBER"] === "local");
    const env = useSbx ? "dev" : environment;

    const applicationId = useSbx
      ? "8776b6df-e351-4f78-8ec2-7307e85971cb"
      : "cf2c8085-842f-4f03-bc52-66c0a2371ec0";
    const clientToken = useSbx
      ? "pub8e4c83b4d6fb0ed8475163c4ee3bcbee"
      : "pubaac0ccd5bba453f98fc2790fb4e245ff";

    return {
      applicationId: applicationId,
      clientToken: clientToken,
      site: "datadoghq.com",
      service: "digital-claims-bridge-spa",
      env: env,
      version: version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: "mask-user-input",
    };
  }
}
